import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export const usePatchNotificationRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      notificationRule: Pick<
        NotificationRule,
        | 'notificationRuleId'
        | 'cooldownPeriod'
        | 'status'
        | 'notificationTemplate'
        | 'notificationPreviewTemplate'
      >
    ) => {
      const { notificationRuleId } = notificationRule;

      return toast.promise(
        client.patch(`/notifications/rules/${notificationRuleId}`, {
          cooldownPeriod: notificationRule.cooldownPeriod,
          status: notificationRule.status,
          notificationTemplate: notificationRule.notificationTemplate,
          notificationPreviewTemplate: notificationRule.notificationPreviewTemplate,
        }),
        {
          loading: 'Updating notification rule...',
          success: 'Successfully updated the notification rule.',
          error: (_: unknown) =>
            `Uh oh, there was an error with updating the notification rule.`,
        }
      );
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
